/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Whether the applied filters have excluded everything, as opposed to the category simply being
 * empty. The single source of truth for that distinction.
 *
 * Two callers need the SAME answer: `InvalidFilterCombination`, which renders the explanation, and
 * the routes, which pass `suppressEmptyMessage` to `ProductGrid` so its generic "no products found"
 * does not stack underneath. They are exact complements, and two independent spellings of one rule
 * drift into either both messages rendering or neither.
 *
 * Its own module rather than a second export from the component, because a module that exports both
 * a component and a plain function loses Fast Refresh granularity (`react-refresh/only-export-
 * components`, which this project lints at `--max-warnings 0`).
 */
export function isOverFiltered(total: number, refineCount: number): boolean {
    return total === 0 && refineCount > 0;
}
